<!--
  ONE ROOMY CARD, SPLIT IN TWO: the intent on the left, the single thing to do on the right.

  The shell owns what is the same on all nine screens -- the canvas, the brand panel with the mark
  at its head and the reassurance at its foot -- so they live here rather than in nine templates.
  Each SCREEN contributes exactly two elements, `.auth-intro` (left, between the mark and the
  reassurance) and `.auth-main` (right). How those land in the right cells is explained on
  `.auth-card` in the stylesheet.
-->
<div class="auth-page">
  <main class="auth-card" role="main">
    <div class="auth-brand">
      <!-- The Gozem mark -- the same symbol as the favicon, from the admin's full-resolution asset
           (1047x865) so it stays crisp on any display -- not a text placeholder spelling the name. -->
      <img ngSrc="images/gozem-mark.png" alt="Gozem" width="39" height="32" priority />
      <span class="auth-brand-divider" aria-hidden="true"></span>
      <span class="auth-brand-label">Accounts</span>
    </div>
    <router-outlet />

    <!--
      THE FOOT OF THE BRAND PANEL, and the reason the left column no longer trails off into white.

      Three statements about what this sign-in is, kept to facts the flow actually delivers: one
      account across the applications, a code on every new device, a password that never leaves
      the sign-in. Nothing here is a control -- the rule of the split (everything actionable lives in
      `.auth-main`) holds -- except the one quiet help link, a route to the page that tells someone
      what to include when they get in touch. The page-level footer that used to carry it is gone:
      a legal strip under a sign-in card is chrome for a website, not for a task, and the two legal
      URLs it linked were never verified (see the TODO it carried).
    -->
    <aside class="auth-aside" aria-label="About Gozem Accounts">
      <ul class="auth-points">
        <li>
          <span class="auth-point-icon" aria-hidden="true"><i class="pi pi-th-large"></i></span>
          <span>One account for every Gozem application</span>
        </li>
        <li>
          <span class="auth-point-icon" aria-hidden="true"><i class="pi pi-shield"></i></span>
          <span>A one-time code protects every new device</span>
        </li>
        <li>
          <span class="auth-point-icon" aria-hidden="true"><i class="pi pi-lock"></i></span>
          <span>Your password never leaves this sign-in</span>
        </li>
      </ul>
      <a class="auth-help" routerLink="/support">Need help signing in?</a>
    </aside>
  </main>
</div>
